import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom-v6'
import { toast } from 'sonner'
import { ApiError } from '@clouway/api'

import { TrackerActivationForm, type TrackerActivationFormValues } from '../components/TrackerActivationForm'
import { useActivateTrackingObject } from '../hooks'

export function TrackerActivation() {
  const { t } = useTranslation('feature')
  const { id = '' } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { mutateAsync: activate } = useActivateTrackingObject(id)

  const onSubmit = async (values: TrackerActivationFormValues) => {
    // Map the form shape to the wire request — vendorId is form-only.
    try {
      const object = await activate({
        lpn: values.lpn,
        label: values.label,
        type: values.type,
        msisdn: values.msisdn,
        trackingId: values.trackingId,
        deviceModelId: values.deviceModelId,
      })
      toast.success(t('trackingObjects.activationForm.successMessageTitle'), {
        description: t('trackingObjects.activationForm.successMessageDescription'),
      })
      navigate(`/customers/${id}/tracking-objects/${object.id}/status`)
    } catch (error) {
      const code = error instanceof ApiError ? error.code : undefined
      const description =
        code === 'no_active_applications'
          ? t('trackingObjects.activationForm.noActiveApplications')
          : `${t('trackingObjects.activationForm.errorDescription')}${error instanceof ApiError ? error.status : ''}`
      toast.error(t('trackingObjects.activationForm.errorMessage'), { description })
    }
  }

  return <TrackerActivationForm onSubmit={onSubmit} />
}
